// extracted by css-extract-rspack-plugin
export default {"addPaymentDialogV2Container":"addPaymentDialogV2Container-FrOg8G"};